import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'anf-core-react';
import CompareFabricsModal from '../CompareFabricsModal/CompareFabricsModal';
import AnalyticsTriggers from '../../../analytics/analyticsTriggers';

export default function CompareFabricsSection({ label, brand, header }) {
  const [isOpenCompareFabricsModal, setIsOpenCompareFabricsModal] = useState(false);

  const handleOpenCompareFabricsModal = () => {
    setIsOpenCompareFabricsModal(true);
    AnalyticsTriggers.universalClick('open', 'compare modal');
  };

  return (
    <>
      <div className="compare-fabrics-section" data-product-brand={brand}>
        <h3 className="compare-fabrics-section__header">
          {header}
          :
        </h3>
        <Link
          className="link-button"
          brand={brand}
          onClick={handleOpenCompareFabricsModal}
        >
          {label}
        </Link>
      </div>
      <CompareFabricsModal
        isOpenCompareFabricsModal={isOpenCompareFabricsModal}
        setIsOpenCompareFabricsModal={setIsOpenCompareFabricsModal}
      />
    </>
  );
}

CompareFabricsSection.propTypes = {
  label: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
};
